export default class AdvertisingSizes {
  constructor() {
    this.advertisingSizes = {
      sizesLandscape: [[300, 100], [728, 90], [840, 150], [300, 50], [320, 100], [320, 50], [970, 250]],
      sizeLandscapeMappingRules: [
        [[0, 0], [[300, 100], [300, 50], [320, 100], [320, 50]]],
        [[728, 0], [[728, 90]]],
        [[840, 0], [[840, 150]]],
        [[992, 0], [[970, 250]]],
      ],
      sizesPortrait: [[300, 250], [300, 600]],
      sizePortraitMappingRules: [
        [[0, 0], [[300, 250]]],
        [[992, 0], [[300, 250], [300, 600]]],
      ],
    };
  }
}
